import Swal from 'sweetalert2';
import { handleLogout } from './handleLogout';

export const errorManager = (error) => {
    if (error.includes('Failed to fetch')) {
        return false;
    } else if (error.includes('Sesión invalida')) {
        Swal.fire(
            error,
            "La sesión ya expiró, vuelve a iniciar sesión para continuar",
            'error').then((_) => {
                handleLogout();
            })
    } else {
        Swal.fire({
            icon: 'error',
            title: 'Ocurrió un error inesperado',
            text: error
        });
    }
}